export const PLATFORM_ACCESS_ROUTING = {
  Archive: 'archive',
  CoPlatform: 'co-platform',
  Indexation: 'indexation',
} as const;
